import React from "react";
import home1 from "../img/profile.jpg";
import { About, Description, Image } from "../styles";
//Framer Motion
import { motion } from "framer-motion";
import { photoAnim3, scrollReveal } from "../animation";
import Wave from "./Wave";
import { useScroll } from "./useScroll";

const Another = () => {
  const [element, controls] = useScroll();
  return (
    <About
      variants={scrollReveal}
      ref={element}
      animate={controls}
      initial="hidden"
    >
      <Description>
        <motion.p variants={scrollReveal}>
          <span
            style={{ fontSize: "50px", color: "#7a3b2e", fontFamily: "italic" }}
          >
            A Full
          </span>{" "}
          <span
            style={{
              color: "#e4d1d1",
              fontSize: "27px",
              fontWeight: "70",
              fontFamily: "-moz-initial",
            }}
          >
            Stack Developer & developing tools that can serve purposes and can
            contribute to the real-world case scenario. Developing tools with
            the mindset of Its serving purpose tuning with passions and
            creativity. Over the last year, he gathered knowledge in several
            parts of web development by himself. His ultimate goal is to become
            a skilled full-stack web developer.
          </span>
        </motion.p>
      </Description>
      <Image>
        <motion.img variants={photoAnim3} src={home1} alt="guy with a camera" />
      </Image>
      <Wave />
    </About>
  );
};

//Styled Components

export default Another;
